// @ts-ignore
export const all = (state) => state;
// @ts-ignore
export const required = (state) => state.required;
